import { render, staticRenderFns } from "./PageABCBookReader.vue?vue&type=template&id=1f752d09&scoped=true&"
import script from "./PageABCBookReader.vue?vue&type=script&lang=js&"
export * from "./PageABCBookReader.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookReader.vue?vue&type=style&index=0&id=1f752d09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f752d09",
  null
  
)

export default component.exports